import { Plugin } from 'ckeditor5';

export default class HorizontalLineAllowStyles extends Plugin {
    static get pluginName() { return "HorizontalLineAllowStyles" }

    init() {
        const editor = this.editor;

        //Allow hr attributes with this plugin. Setting in GeneralHtmlSupport is bugged.. https://github.com/ckeditor/ckeditor5/issues/12973

        //Allow tyles for hr
        editor.model.schema.extend('horizontalLine', { allowAttributes: ['hrStyle'] })
        editor.conversion.attributeToAttribute({
            model: 'hrStyle',
            view: 'style'
        });
    }
}
